import React from "react"
import type { ModalDrawerProps } from "@ng-mw/reol/components/ModalDrawer"
import ModalDrawer from "@ng-mw/reol/components/ModalDrawer"
import PopupHeader from "@modules/popup/PopupHeader"

interface FeedbackDrawerProps {
    children: React.ReactNode
    drawerSize?: ModalDrawerProps["size"]
    footer?: React.ReactNode
    isOpen: boolean
    onClose: () => void
}

/**
 * Shared shell for feedback flows. Individual flows can provide their own
 * questions and metadata while keeping the drawer behavior consistent.
 */
const FeedbackDrawer = ({
    children,
    drawerSize = "dynamic",
    footer,
    isOpen,
    onClose,
}: FeedbackDrawerProps) => {
    return (
        <ModalDrawer
            ariaLabel="Tilbakemelding"
            isOpen={isOpen}
            onClose={onClose}
            size={drawerSize}
            footer={footer}
            header={
                <PopupHeader
                    isActionsOverflow
                    onClose={onClose}
                />
            }
        >
            {children}
        </ModalDrawer>
    )
}

export default FeedbackDrawer
